import AjaxRequest from './AjaxRequest';

export default class School {
    searchSchools(data) {
        return new AjaxRequest().get('schools/search', data);
    }
}
